// Capture & store a referral code from `?ref=XXXXXXX` for up to 30 days.
// Used by Landing/Register and the auth flow.
const KEY = "pronto_ref";
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export function captureRefFromUrl() {
  if (typeof window === "undefined") return null;
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get("ref");
    if (!raw) return null;
    const code = String(raw).trim().toUpperCase();
    if (!/^[A-Z0-9]{5,12}$/.test(code)) return null;
    const payload = { code, ts: Date.now() };
    window.localStorage.setItem(KEY, JSON.stringify(payload));
    return code;
  } catch {
    return null;
  }
}

export function getStoredRef() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const { code, ts } = JSON.parse(raw);
    if (!code || Date.now() - ts > MAX_AGE_MS) {
      window.localStorage.removeItem(KEY);
      return null;
    }
    return code;
  } catch {
    return null;
  }
}

export function clearStoredRef() {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
}
